export default __webpack_public_path__ + "static/media/playgame_btn.f9881d0c.png";